import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { useToast } from "../Toast/ToastContext";

function Sales() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [showModal, setShowModal] = useState(false);
  const [selectedSalesId, setSelectedSalesId] = useState(null);

  // Helper: returns "English / Tamil" or just "English"
  const itemLabel = (itemObj) => {
    if (!itemObj) return "-";
    const eng = itemObj.item_name_english || itemObj.item || "";
    const tam = itemObj.item_name_tamil || "";
    return tam ? `${eng} / ${tam}` : eng;
  };

  const [actionType, setActionType] = useState(""); // "Edit" or "Delete"
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent multiple submissions
  const [notifications, setNotifications] = useState([]); // Store notification data

  // Open and close modal functions
  const openModal = (id, action) => {
    setSelectedSalesId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedSalesId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  // Fetch notification data
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      console.log("responsesddddddd", response.data);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
    }
  };

  // Check notification status
  const checkNotificationStatus = (salesId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === salesId &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.viewed === "false" &&
        notif.employe_id === userId
    );
  };

  // Check for existing pending notification
  const hasPendingNotification = (salesId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === salesId &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  // Handle notification submission
  const handlesubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedSalesId, actionType)) {
      alert("the handle submit functio is called");
      // toast.warn("A pending request for this action already exists!");
      closeModal();
      return;
    }
    setLoading(true);
    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "sales",
        table_id: selectedSalesId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      console.log("Notification formData:", formData);

      const response = await axios.post(
        `${ApiUrl}/Api/notification.php`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("Notification submitted:", response.data);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      // toast.success(`${actionType} request sent successfully!`);
      closeModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error("Error submitting notification. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle edit action
  const handleUpdateSales = (id) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(`/update-sales/${id}`);
      } else {
        openModal(id, "Edit");
      }
    } else {
      navigate(`/update-sales/${id}`);
    }
  };

  // Get sales data
  const [responseData, setResponseData] = useState([]);

  // useEffect(() => {
  //   fetchData();
  //   fetchNotifications();
  // }, []);

  useEffect(() => {
    fetchData();
    fetchNotifications();
    const interval = setInterval(() => {
      // alert("set interval called");
      fetchData();
      fetchNotifications();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const localRole = localStorage.getItem("role");
  const localUsername = localStorage.getItem("username");

  const fetchData = async () => {
    // try {
    //   const response = await axios.get(`${ApiUrl}/Api/sales.php`);
    //   console.log("Response from server:", response.data);
    //   setResponseData(response.data?.data || []);
    // } catch (error) {
    //   console.error("Error fetching data:", error.message);
    // }

    try {
      // setLoading(true);
      const response = await axios.get(
        localRole === "Employee"
          ? `${ApiUrl}/Api/sales.php?employee_id=${localUsername}`
          : `${ApiUrl}/Api/sales.php`
      );
      console.log("Response from server:", response.data);
      setResponseData(response.data?.data || []);
      // setTimeout(() => {
      //   setLoading(false);
      // }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch data", 3000, "topRight");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  // Delete modal and logic
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");

  const handleprint = (id, sales_no) => {
    // Navigate to dynamic route
    // navigate(`/sales-bill/${sales_no}`);
    navigate(`/bill/${sales_no}`);
  };

  const handleOpenModal = (id, sales_no) => {
    const userRole = localStorage.getItem("role");

    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Delete")) {
        setdeleteid(id);
        setdeletename(sales_no);
        setDeleteShowModals(true);
      } else {
        openModal(id, "Delete");
      }
    } else {
      setdeleteid(id);
      setdeletename(sales_no);
      setDeleteShowModals(true);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setdeleteid("");
    setdeletename("");
  };

  const userId = localStorage.getItem("username");

  const handleDelete = async () => {
    try {
      // First, fetch the notification data for this sales record
      const notificationResponse = await axios.get(
        `${ApiUrl}/Api/notification.php?table_id=${getdeleteid}`
      );

      let notificationData = null;
      if (
        notificationResponse.data?.status &&
        notificationResponse.data.data?.length > 0
      ) {
        // Get the relevant notification for this delete action
        notificationData = notificationResponse.data.data.find(
          (notif) =>
            notif.table_id === getdeleteid.toString() &&
            notif.button_value === "Delete" &&
            notif.viewed === "false"
        );
      }

      // Perform the delete operation
      const response = await axios.delete(
        `${ApiUrl}/Api/sales.php/${getdeleteid}`
      );

      console.log("Delete response:", response.data);

      if (response.data?.status) {
        // If we have notification data, update its viewed status
        if (notificationData) {
          try {
            const currentTime = new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " ");

            const notificationPayload = {
              id: notificationData.id,
              viewed: "true",
              updated_by: userId,
              updated_date: currentTime,
              // Include all required fields from the original notification
              table_name: notificationData.table_name,
              table_id: notificationData.table_id,
              employe_id: notificationData.employe_id,
              status: notificationData.status,
              button_value: notificationData.button_value,
              time: notificationData.time,
              created_date: notificationData.created_date,
            };

            console.log(
              "Updating notification with payload:",
              notificationPayload
            );

            const notificationUpdateResponse = await axios.put(
              `${ApiUrl}/Api/notification.php/${notificationData.id}`,
              notificationPayload,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            console.log(
              "Notification update response:",
              notificationUpdateResponse.data
            );
          } catch (notificationError) {
            console.error("Error updating notification:", notificationError);
            if (notificationError.response) {
              console.error(
                "Server responded with:",
                notificationError.response.data
              );
            }
          }
        }

        // Close modal and refresh data
        handleCloseModal();
        fetchData();
        fetchNotifications();
        // toast.success("Deleted successfully!");
      } else {
        alert(response.data.message || "Failed to delete sales data");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      if (error.response) {
        console.error("Server responded with:", error.response.data);
      }
      // toast.error("Error deleting data. Please try again.");
    }
  };

  // Pagination and search
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = responseData.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (item.sales_no && item.sales_no.toLowerCase().includes(searchLower)) ||
      (item.item_list[0]?.category &&
        item.item_list[0]?.category.toLowerCase().includes(searchLower)) ||
      (item.item_list[0]?.item &&
        item.item_list[0]?.item.toLowerCase().includes(searchLower)) ||
      (item.customer_id &&
        item.customer_id.toLowerCase().includes(searchLower)) ||
      (item.status && item.status.toLowerCase().includes(searchLower)) ||
      (item.total && item.total.toLowerCase().includes(searchLower)) ||
      (item.net_total && item.net_total.toLowerCase().includes(searchLower))  ||
      (item.balance && item.balance.toLowerCase().includes(searchLower)) 

    );
  });

  const totalItems = filteredData.length;
  const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

  const currentItems = showAllItems
    ? filteredData
    : filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(1)}>
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Export Functions
  const exportPDF = () => {
    try {
      const doc = new jsPDF();

      // Add title
      doc.setFontSize(16);
      doc.text("Sales Report", 14, 20);

      // Add current date
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

      // Prepare table data
      const tableData = filteredData.map((item, index) => [
        index + 1,
        item.sales_no || "",
        item.sales_date || "",
        item.item_list[0]?.category || "",
        itemLabel(item.item_list[0]),
        item.customer_id || "",
        item.total || "",
        item.net_total || "",
      ]);

      // Add table
      autoTable(doc, {
        head: [
          [
            "S.No",
            "Sales No",
            "Sales Date",
            "Category",
            "Type",
            "Customer ID",
            "Total",
            "Net Total",
          ],
        ],
        body: tableData,
        startY: 40,
        theme: "striped",
        headStyles: { fillColor: [41, 128, 185] },
        styles: { fontSize: 8, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 25 },
          3: { cellWidth: 25 },
          4: { cellWidth: 25 },
          5: { cellWidth: 25 },
          6: { cellWidth: 20 },
          7: { cellWidth: 20 },
        },
      });

      // Save the PDF
      doc.save("sales_report.pdf");
      toast.success("Pdf exported successfully!", 2000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      alert("Error exporting PDF. Please try again.");
    }
  };

  const exportExcel = () => {
    try {
      // Prepare data for Excel
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        "Sales No": item.sales_no || "",
        "Sales Date": item.sales_date || "",
        Category: item.item_list[0]?.category || "",
        Type: itemLabel(item.item_list[0]),
        "Customer ID": item.customer_id || "",
        Total: item.total || "",
        "Net Total": item.net_total || "",
      }));

      // Create workbook and worksheet
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();

      // Set column widths
      const colWidths = [
        { wch: 8 }, // S.No
        { wch: 15 }, // Sales No
        { wch: 15 }, // Sales Date
        { wch: 15 }, // Category
        { wch: 15 }, // Type
        { wch: 15 }, // Customer ID
        { wch: 12 }, // Total
        { wch: 12 }, // Net Total
      ];
      ws["!cols"] = colWidths;

      XLSX.utils.book_append_sheet(wb, ws, "Sales");

      // Save the file
      XLSX.writeFile(wb, "sales_report.xlsx");
      toast.success("Excel file exported successfully!", 2000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error);
      alert("Error exporting Excel. Please try again.");
    }
  };

  const exportCSV = () => {
    try {
      // Prepare CSV data
      const csvData = [
        [
          "S.No",
          "Sales No",
          "Sales Date",
          "Category",
          "Type",
          "Customer ID",
          "Total",
          "Net Total",
        ],
      ];

      filteredData.forEach((item, index) => {
        csvData.push([
          index + 1,
          item.sales_no || "",
          item.sales_date || "",
          item.item_list[0]?.category || "",
          itemLabel(item.item_list[0]),
          item.customer_id || "",
          item.total || "",
          item.net_total || "",
        ]);
      });

      // Convert to CSV string
      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      // Create and download file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "sales_report.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("CSV file exported successfully!", 2000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error);
      alert("Error exporting CSV. Please try again.");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = [
        "S.No",
        "Sales No",
        "Sales Date",
        "Category",
        "Type",
        "Customer ID",
        "Total",
        "Net Total",
      ];

      const rows = (filteredData || []).map((item, index) => [
        index + 1,
        item.sales_no || "",
        item.sales_date || "",
        item.item_list?.[0]?.category || "",
        itemLabel(item.item_list?.[0]),
        item.customer_id || "",
        item.total || "",
        item.net_total || "",
      ]);

      // Quote each field and format the output
      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard
          .writeText(formattedText)
          .then(() => {
            toast.success(
              "Data copied to clipboard successfully!",
              2000,
              "topRight"
            );
          })
          .catch((err) => {
            console.error("Clipboard API failed:", err);
            fallbackCopy(formattedText);
          });
      } else {
        fallbackCopy(formattedText);
      }
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error);
      alert("Error copying data. Please try again.");
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Style the textarea to be invisible
      textArea.style.position = "fixed";
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = 0;
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        toast.success("Print dialog opened!", 2000, "topRight");
      } else {
        alert("Failed to copy data.");
      }
    } catch (err) {
      console.error("Fallback copy failed:", err);
      toast.success("Error copying data. Please try again", 2000, "topRight");
    }
  };

  const handlePrint = () => {
    try {
      // Create a new window for printing
      const printWindow = window.open("", "_blank");

      // Prepare HTML content for printing
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Sales Report</title>
            <style>
                body { font-family: Arial, sans-serif; margin: 20px; }
                h1 { color: #333; text-align: center; }
                .date { text-align: center; margin-bottom: 20px; color: #666; }
                table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; font-weight: bold; }
                tr:nth-child(even) { background-color: #f9f9f9; }
                @media print {
                    body { margin: 0; }
                    .no-print { display: none; }
                }
            </style>
        </head>
        <body>
            <h1>Sales Report</h1>
            <div class="date">Generated on: ${new Date().toLocaleDateString()}</div>
            <table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Sales No</th>
                        <th>Sales Date</th>
                        <th>Category</th>
                        <th>Type</th>
                        <th>Customer ID</th>
                        <th>Total</th>
                        <th>Net Total</th>
                    </tr>
                </thead>
                <tbody>
                    ${filteredData
                      .map(
                        (item, index) => `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.sales_no || ""}</td>
                            <td>${item.sales_date || ""}</td>
                            <td>${item.item_list[0]?.category || ""}</td>
                            <td>${itemLabel(item.item_list[0])}</td>
                            <td>${item.customer_id || ""}</td>
                            <td>${item.total || ""}</td>
                            <td>${item.net_total || ""}</td>
                        </tr>
                    `
                      )
                      .join("")}
                </tbody>
            </table>
        </body>
        </html>
      `;

      printWindow.document.write(printContent);
      printWindow.document.close();

      // Wait for content to load then print
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };

      toast.success("Print dialog opened!", 2000, "topRight");
    } catch (error) {
      console.error("Error printing:", error);
      toast.error("Error printing. Please try again", 2000, "topRight");
    }
  };

  // Helper function to format date as dd-mm-yyyy
  const formatDate = (dateString) => {
    if (!dateString) return "";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid date

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString; // Return original if error occurs
    }
  };

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid">
        <div className="d-flex mb-2">
          <h6 className="card-title m-2">Sales</h6>
          <button
            className="btn btn-primary btn-sm rounded-3"
            onClick={() => navigate("/add-sales")}
          >
            Add <span className="ms-2">+</span>
          </button>
        </div>

        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div className="d-flex">
                <label className="form-label text-dark mt-2">Show : </label>
                <div>
                  <select
                    className="form-control mx-2"
                    onChange={handleItemsPerPageChange}
                    value={showAllItems ? "All" : itemsPerPage}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Center - Export/Action buttons */}
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                >
                  Excel
                </button>
              </div>

              <div className="search-container">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card tableCard p-2">
              <div className="table-responsive">
                <table className="table">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Sales ID</th>
                      <th scope="col">Sales Date</th>
                      <th scope="col">Category</th>
                      <th scope="col">Item Name</th>
                      <th scope="col">Customer ID</th>
                      <th scope="col">Total</th>
                      <th scope="col">Net Total</th>
                      <th scope="col">Balance</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((item, index) => {
                      const status = item.notifications?.[0]?.status;

                      // console.log("status is here", status);
                      let rowClass = "";
                      if (status) {
                        switch (status) {
                          case "accepted":
                            rowClass = "table-secondary";
                            break;
                          case "rejected":
                            rowClass = "table-danger";
                            break;
                          case "requested":
                            rowClass = "table-info";
                            break;
                        }
                      }

                      return (
                        <tr key={item.id} className={rowClass}>
                          <td>{index + 1}</td>
                          <td>{item.sales_no}</td>
                          {/* <td>{item.sales_date}</td> */}
                          <td>{formatDate(item.sales_date)}</td>
                          <td>{item.item_list[0]?.category}</td>
                         <td>
                            {item.item_list?.[0]?.item_name_english
                              ? `${item.item_list[0].item_name_english}${item.item_list[0].item_name_tamil ? " / " + item.item_list[0].item_name_tamil : ""}`
                              : (item.item_list?.[0]?.item_name_english || item.item_list?.[0]?.item || "-")}
                          </td>

                          <td>{item.customer_id}</td>
                          <td>{item.total}</td>
                          <td>{item.net_total}</td>
                          <td>{item.balance}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-light me-1"
                              onClick={() => handleUpdateSales(item.id)}
                            >
                              <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-light"
                              onClick={() =>
                                handleOpenModal(item.id, item.sales_no)
                              }
                            >
                              <i className="fa-solid fa-trash text-danger fs-6"></i>
                            </button>

                            <button
                              className="btn btn-sm btn-light"
                              onClick={() =>
                                handleprint(item.id, item.sales_no)
                              }
                            >
                              <i className="fa-solid fa-print text-secondary fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First"
                        >
                          <span aria-hidden="true">&laquo;&laquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous"
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                      </li>

                      {renderPageNumbers()}

                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next"
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last"
                        >
                          <span aria-hidden="true">&raquo;&raquo;</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            {/* Delete Confirmation Modal */}
            <div
              className={`modal fade ${deleteShowModals ? "show" : ""}`}
              style={{
                display: deleteShowModals ? "block" : "none",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
              tabIndex="-1"
              aria-labelledby="deleteConfirmModalLabel"
              aria-modal="true"
            >
              <div className="modal-dialog modal-dialog-centered modal-confirm">
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <div className="d-flex justify-content-center mb-3">
                      <div
                        className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                        style={{
                          width: "80px",
                          height: "80px",
                          margin: "0 auto",
                        }}
                      >
                        <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                      </div>
                    </div>
                    <h4 className="modal-title mb-3 text-center">
                      Are you sure?
                    </h4>
                    <h6 className="mb-4 text-center">
                      Do you really want to delete this
                      <span className="text-primary">({getdeletename})</span>?
                    </h6>
                    <div className="d-flex btn-group">
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm flex-grow-1"
                        onClick={handleCloseModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm flex-grow-1 mx-2"
                        onClick={handleDelete}
                        disabled={isSubmitting}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Edit/Delete Request Modal */}
            <div
              className={`modal fade ${showModal ? "show" : ""}`}
              style={{
                display: showModal ? "block" : "none",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
              tabIndex="-1"
              aria-labelledby="requestModalLabel"
              aria-hidden={!showModal}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h6
                      className="modal-title text-primary"
                      id="requestModalLabel"
                    >
                      Send {actionType} Request to Admin
                    </h6>
                    <button
                      type="button"
                      className="btn-close"
                      style={{ fontSize: "10px" }}
                      onClick={closeModal}
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handlesubmit}>
                      <p className="text-center">
                        Do you want to request to {actionType.toLowerCase()}{" "}
                        this sale?
                      </p>
                      <div className="text-center mt-4">
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm px-4 me-2"
                          onClick={closeModal}
                        >
                          No
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm px-4"
                          disabled={isSubmitting}
                        >
                          Yes
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {(deleteShowModals || showModal) && (
              <div className="modal-backdrop fade show"></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Sales;